import { Search, X } from 'lucide-react';
import type { ChangeEvent } from 'react';

type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  width?: number | string;
  autoFocus?: boolean;
};

const SearchInput = ({
  value,
  onChange,
  placeholder = 'Поиск…',
  width = 280,
  autoFocus,
}: SearchInputProps) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        height: 32,
        padding: '0 8px 0 10px',
        background: 'var(--shell-bg-surface)',
        border: '1px solid var(--shell-border-subtle)',
        borderRadius: 'var(--shell-radius-md)',
        width,
        maxWidth: '100%',
        transition: 'border-color var(--shell-transition-fast)',
      }}
      onFocus={(e) => {
        (e.currentTarget as HTMLElement).style.borderColor = 'var(--shell-accent-primary)';
      }}
      onBlur={(e) => {
        (e.currentTarget as HTMLElement).style.borderColor = 'var(--shell-border-subtle)';
      }}
    >
      <Search size={14} strokeWidth={1.75} color="var(--shell-text-tertiary)" />
      <input
        autoFocus={autoFocus}
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          flex: 1,
          border: 'none',
          outline: 'none',
          background: 'transparent',
          fontSize: 13,
          color: 'var(--shell-text-primary)',
          fontFamily: 'inherit',
          minWidth: 0,
        }}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Очистить"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 18,
            height: 18,
            border: 'none',
            background: 'transparent',
            color: 'var(--shell-text-tertiary)',
            cursor: 'pointer',
            borderRadius: 999,
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLElement).style.background = 'var(--shell-bg-hover)';
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLElement).style.background = 'transparent';
          }}
        >
          <X size={12} strokeWidth={2} />
        </button>
      )}
    </div>
  );
};

export default SearchInput;
